import { render, staticRenderFns } from "./BankNameOkasan.vue?vue&type=template&id=10e5547a&scoped=true&"
import script from "./BankNameOkasan.vue?vue&type=script&lang=ts&"
export * from "./BankNameOkasan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5547a",
  null
  
)

export default component.exports